
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import StyleGuide, { StyleGuideHomePage } from 'shared/library/pages/StyleGuide';
const StyleGuidePage = () => (<StyleGuide slug="/" title="Home">
    <StyleGuideHomePage />
  </StyleGuide>);
export default StyleGuidePage;

    async function __Next_Translate__getStaticProps__197a18a66e9__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/styleguide/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__197a18a66e9__ as getStaticProps }
  